import TextComponent, {
  type ITextComponents,
} from '@allesauto/core/textComponent';
import translate from '@allesauto/i18n';
import { VIN_IMAGE } from '@allesauto/utils/consts';
import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import InformationOverlay from '@/components/InformationOverlay/InformationOverlay';

import { closeOverlay, openOverlay } from '@/store/redux/actions/app';

/**
 * @deprecated
 */
const TextComponentContainer: FC<React.PropsWithChildren<ITextComponents>> = (
  props: ITextComponents
) => {
  const dispatch = useDispatch();
  const intl = useIntl();

  const openVinOverlay = () => {
    dispatch(
      openOverlay({
        children: (
          <InformationOverlay
            description={translate(
              intl,
              'ui.INFORMATION_OVERLAYS.VIN.DESCRIPTION'
            )}
            imageTitle={translate(intl, 'ui.INFORMATION_OVERLAYS.IMAGE_TITLE')}
            image={
              // eslint-disable-next-line @next/next/no-img-element
              <img
                src={VIN_IMAGE}
                alt={translate(intl, 'ui.INFORMATION_OVERLAYS.VIN.DESCRIPTION')}
                className="w-full"
              />
            }
            ctaLabel={translate(intl, 'ui.INFORMATION_OVERLAYS.CLOSE_BUTTON')}
            onButtonClick={() => dispatch(closeOverlay())}
          />
        ),
        title: translate(intl, 'ui.INFORMATION_OVERLAYS.VIN.HEADLINE'),
      })
    );
  };

  return (
    <div>
      <TextComponent {...props} handleAction={openVinOverlay} />
    </div>
  );
};

export default TextComponentContainer;
